import { lazy } from 'react'
import suspenseComponent from 'client/util/suspenseComponent'

// Containers
const FolderUpdateContainer = lazy(() => import('client/containers/dashboard/Folders/containers/FolderUpdateContainer'))

// Components Pages
const DescriptionsPage = lazy(() => import('client/containers/dashboard/Folders/pages/FolderUpdate/DescriptionsPage'))
const PhotosPage = lazy(() => import('client/containers/dashboard/Folders/pages/FolderUpdate/PhotosPage'))
const ShippingFeesPage = lazy(() => import('client/containers/dashboard/Folders/pages/FolderUpdate/ShippingFeesPage'))


const FolderUpdateRoutes = ({ path, typePath }) => [
  {
    path: `${path}/folders/:folders_id/update`,
    component: suspenseComponent(FolderUpdateContainer),
    params: { typePath },
    routes: [
      {
        path: `${path}/folders/:folders_id/update`,
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        component: suspenseComponent(DescriptionsPage)
      },
      {
        path: `${path}/folders/:folders_id/update/photos`,
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        component: suspenseComponent(PhotosPage)
      },
      {
        path: `${path}/folders/:folders_id/update/shipping-fees`,
        exact: true,
        auth: { reqAuthBiz: true, reqExpDate: true },
        component: suspenseComponent(ShippingFeesPage)
      }
    ]
  }
]

export default FolderUpdateRoutes
